"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalAdapter = void 0;
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const axios_1 = __importDefault(require("axios"));
const helperFunctions_1 = require("./utility/helperFunctions");
const Adapter_1 = require("./Adapter");
const Types_1 = require("./Types");
const ParserService_1 = require("./ParserService");
class LocalAdapter extends Adapter_1.Adapter {
    constructor(options, adapterOptions) {
        super(options);
        this.channels = [];
        this.adapterOptions = (0, helperFunctions_1.defaultTo)(adapterOptions, {});
        this.setName();
        this.addInitialChannels();
    }
    addInitialChannels() {
        if (this.adapterOptions.initialChannels) {
            this.adapterOptions.initialChannels.forEach((channelName) => {
                this.addChannel(channelName);
            });
        }
    }
    setListeners() {
        if (this.instance) {
            this.instance.on('connect', () => {
                this.subscribeAll();
            });
        }
    }
    subscribe(channelName) {
        if (this.instance) {
            this.instance.emit('subscribe', {
                channel: channelName,
            });
            this.instance.on(channelName, (payload) => {
                const data = payload.data || {};
                (0, ParserService_1.parseAndDispatchEvent)(payload.type, Object.assign(data, { sentTime: payload.sentTime }), this.useCommonEventName, this.name, this.options.proxyEvents, this.options.bounceToFrames);
            });
        }
    }
    subscribeAll() {
        this.channels.forEach((channel) => {
            this.subscribe(channel.channelName);
        });
    }
    unsubscribe(channelName) {
        if (this.instance) {
            this.instance.emit('unsubscribe', {
                channel: channelName,
            });
        }
    }
    unsubscribeAll() {
        this.channels.forEach((channel) => {
            this.unsubscribe(channel.channelName);
        });
    }
    findChannelIndex(channelName) {
        return this.channels.findIndex((n) => n.channelName === channelName);
    }
    setName() {
        this.name = Types_1.Adapters.LocalAdapter;
    }
    getEndpoint() {
        return 'http://127.0.0.1:8070';
    }
    getHttpEndpoint() {
        return 'http://127.0.0.1:8071/publish';
    }
    connect() {
        this.instance = (0, socket_io_client_1.default)(this.getEndpoint(), {
            transports: ['websocket'],
        });
        this.setListeners();
    }
    disconnect() {
        if (this.instance) {
            this.unsubscribeAll();
            this.instance.disconnect();
        }
    }
    reconnect() {
        if (this.instance && this.instance.disconnected) {
            this.instance.connect();
        }
    }
    addChannel(channelName) {
        if (this.findChannelIndex(channelName) < 0) {
            this.channels.push({
                channelName,
            });
            this.subscribe(channelName);
        }
    }
    removeChannel(channelName) {
        const channelIndex = this.findChannelIndex(channelName);
        if (channelIndex >= 0) {
            this.channels.splice(channelIndex, 1);
            this.unsubscribe(channelName);
        }
    }
    sendMessage(message) {
        if (this.instance) {
            this.instance.emit('message', message);
        }
    }
    async sendManifest(manifest) {
        const url = this.getHttpEndpoint();
        const response = await axios_1.default.post(url, {
            channel: 'assetsMgmt',
            data: manifest,
            type: 'fetchContent',
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
    async getState(message) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, message);
        return new Promise((resolve) => resolve(undefined));
    }
}
exports.LocalAdapter = LocalAdapter;
//# sourceMappingURL=LocalAdapter.js.map